<div [ngClass]="{'w-80 sm:w-56': route.includes('/s')}" class="flex flex-col border border-gray-100 rounded-lg p-3.5 h-full w-56 hover:border-pink-800">
  <div class="flex-1">
    <!-- promocao e fav -->
    <div class="flex justify-end items-center" [ngClass]="{'justify-between': product.price_discount_percent != null}">
      <div *ngIf="product.price_discount_percent != null" class="bg-[#FFBE0B] rounded-md p-1.5">
        <p class="text-black text-xs lg:font-medium">{{product.price_discount_percent | number:'1.0-0'}}%</p>
      </div>

      <button title="Favoritar" (click)="clientMarketplaceWishlistProductServiceCreate(product.id)" class="hover:opacity-80">
        <ng-container *ngIf="clientMarketplacePreferenceFavoriteServiceExists(product); else notCustomerFavorite">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5 stroke-transparent text-pink-800">
            <path
              d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z"
            />
          </svg>
        </ng-container>
        <ng-template #notCustomerFavorite>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 stroke-gray-600">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
          </svg>
        </ng-template>
      </button>
    </div>

    <!-- foto e estrelas -->
    <div>
      <a [routerLink]="['/p/'+product.url_handle+'/id/'+product.id]">
        <ng-container *ngIf="product.image_thumb != ''">
          <div class="flex justify-center">
            <img class="relative bg-white mb-5 overflow-hidden h-36 w-40 object-contain lg:max-w-[75%] lg:h-44" loading="lazy" src="{{product.image_thumb}}" alt="{{product.name}}" />
          </div>
        </ng-container>
        <div class="flex justify-center">
          <ng-container *ngIf="product.image_thumb == ''">
            <img class="relative bg-white mb-5 overflow-hidden h-36 w-40 lg:max-w-[75%] lg:h-44" loading="lazy" src="/assets/images/no_imagem.png" alt="{{product.name}}" />
          </ng-container>
        </div>
      </a>

      <!-- <ng-container *ngIf="product.stars > 0">
        <div class="lg:hidden flex -mt-6 justify-center justify-items-end">
          <div class="bg-gray-50 rounded-full p-2">
            <img class="star w-20" src="/assets/images/star{{product.stars}}.png" accesskey="" />
          </div>
        </div>
      </ng-container> -->
    </div>

    <!-- detalhes e carrinho -->

    <div class="mt-2">
      <p class="text-xs text-gray-700 tracking-widest uppercase sm:font-medium">{{product.category}}</p>
    </div>
    <a class="mt-2 w-40" [routerLink]="['/p/'+product.url_handle+'/id/'+product.id]">
      <p class="text-gray-900 font-semibold">{{product.name}}</p>
    </a>
    <ng-container *ngIf="product.stars > 0">
      <div class="my-2">
        <img class="w-16" src="/assets/images/star{{product.stars}}.png" alt="{{product.stars}} Estrelas de Avaliação" />
      </div>
    </ng-container>
    <ng-container *ngIf="product.inventory_quantity > 0 && product.product_status == 'active'">
      <div class="mt-2 flex flex-col items-start lg:space-x-0">
        <ng-container *ngIf="product.price_compare_at !== product.price">
          <p class="text-xs text-gray-700 line-through sm:text-sm font-medium">R$ {{product.price_compare_at | number:'1.2-2'}}</p>
        </ng-container>
        <p class="text-xl text-pink-800 font-bold sm:text-xxl">R$ {{product.price | number:'1.2-2'}}</p>
      </div>

      <div *ngIf="product.price_installment_no_fee > 0">
        <p class="text-xs text-gray-800"><span class="font-bold">{{product.installment_no_fee}}x</span> de <span class="font-bold">R$ {{product.price_installment_no_fee | number:'1.2-2'}}</span> sem juros*</p>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="product.inventory_quantity > 0 && product.product_status == 'active'">
    <div class="mt-2 flex items-center justify-center">
      <button title="Aumentar" (click)="clientMarketplaceCartProductQuantityMinus()" class="bg-gray-100 rounded-full px-2 cursor-pointer hover:bg-gray-300"><span class="text-center text-lg text-gray-800 font-bold lg:text-xl">-</span></button>
      <input [ngClass]="{'w-60 sm:w-36 md:w-40': route.includes('/s')}" aria-label="Quantidade" type="text" class="w-40 lg:w-[70%] text-center border-transparent text-lg text-gray-800 font-bold lg:text-xl" value="{{inventoryQuantity}}" />
      <button title="Diminuir" (click)="clientMarketplaceCartProductQuantityPlus()" class="bg-gray-100 rounded-full px-2 cursor-pointer hover:bg-gray-300"><span class="text-lg text-gray-800 font-bold lg:text-xl">+</span></button>
    </div>
    <ng-container *ngIf="inventoryQuantity <= product.inventory_quantity && !messageProcess">
      <button (click)="clientMarketplaceCartProductServiceCreate(product)" class="bg-[#FFBE0B] rounded-lg mt-2 hover:bg-amber-500">
        <p class="text-black p-2 text-center text-sm lg:font-medium">Comprar</p>
      </button>
    </ng-container>
    <ng-container *ngIf="messageProcess">
      <button class="bg-pink-900 rounded-lg mt-2">
        <div class="flex items-center justify-center space-x-2 p-2">
          <p-progressSpinner [style]="{ width: '15px', height: '15px' }" styleClass="custom-spinner" strokeWidth="8" fill="transparent" animationDuration=".8s"></p-progressSpinner>
          <p class="text-white text-center text-sm lg:text-base lg:font-medium pb-1">Carregando</p>
        </div>
      </button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="product.inventory_quantity < 1 || product.product_status == 'inactive'">
    <button title="Avise-me quando disponível" (click)="clientMarketplaceNoticeProductServiceCreate(product.id);" class="border border-pink-800 text-pink-800 rounded-lg mt-2 hover:bg-pink-800 hover:text-white">
      <p class="px-3 py-2 font-medium text-center text-sm">Avise-me quando disponível</p>
    </button>
  </ng-container>
</div>

<p-dialog [(visible)]="displayModal" [modal]="true" [baseZIndex]="10000" [draggable]="false" [closable]="true" [breakpoints]="{'960px': '35vw', '670px': '90vw'}">
  <ng-container *ngIf="productAddedToCart?.id">
    <div class="relative p-5">
      <div class="flex flex-col items-center justify-center">
        <div class="mb-5 flex h-10 w-10 items-center justify-center rounded-full bg-green-100 text-green-500">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-6 w-6 lg:h-8 lg:w-8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="text-center">
          <h3 class="text-lg font-semibold text-secondary-900">Produto Adicionado ao Carrinho</h3>
          <div class="mt-2 text-sm text-secondary-500">{{inventoryQuantity}} x {{product.name}}</div>
        </div>
        <button class="py-6 flex justify-center" (click)="displayModal = false">
          <p class="text-pink-800 font-semibold uppercase lg:text-sm hover:text-pink-900">Continuar comprando</p>
        </button>
      </div>

      <div class="mt-3 flex justify-end gap-3">
        <button
          [routerLink]="['/p/checkout']"
          [queryParams]="{uid: cart.client_marketplace_cart_uid, one_click_buy: true}"
          type="button"
          class="flex-1 rounded-lg border border-pink-800 bg-white px-4 py-2 text-center text-sm font-medium text-pink-800 shadow-sm transition-all hover:bg-gray-100 focus:ring focus:ring-gray-100 disabled:cursor-not-allowed disabled:border-gray-100 disabled:bg-gray-50 disabled:text-gray-400"
        >
          Finalizar Compra
        </button>
        <button
          [routerLink]="['/p/cart']"
          [queryParams]="{uid: cart.client_marketplace_cart_uid}"
          type="button"
          class="flex-1 rounded-lg border border-pink-800 bg-pink-800 px-4 py-2 text-center text-sm font-medium text-white shadow-sm transition-all hover:border-pink-900 hover:bg-pink-900 focus:ring focus:ring-pink-900 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-500"
        >
          Carrinho
        </button>
      </div>
    </div>
  </ng-container>
</p-dialog>
